module.exports = __webpack_public_path__ + "static/media/Section 1 BG.ab8a52fc.png";